import queryString from '@promoboxx/query-string-babel'

const buildCommonParams = (payload) => {
  const {
    perPage,
    offset = 0,
    search,
    sortColumn,
    sortDirection,
    filters,
    filtersObject,
    tags,
    fields,
  } = payload
  let params = queryString.stringify(
    {
      per_page: perPage,
      offset,
      search,
      sort_column: sortColumn,
      sort_direction: sortDirection,
      filters: JSON.stringify(filters),
      tags,
      fields,
    },
    { arrayFormat: 'bracket' },
  )

  //Special handling for filters objects.
  //Query params can look like this: filters=<hash>&filters[key]=value
  //Of course the name of the param (filters) interferes with itself and need
  //special handling.
  if (filtersObject) {
    let filtersParams = []
    Object.keys(filtersObject).map((key) => {
      filtersParams.push(`filters[${key}]=${filtersObject[key]}`)
    })
    params = `${params}&${filtersParams.join('&')}`
  }

  if (params) {
    params = `?${params}`
  }

  return params
}

export default buildCommonParams
